module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-app', [_c('v-container', {
    attrs: {
      "fluid": "",
      "fill-height": ""
    }
  }, [_c('v-content', [_c('v-layout', {
    attrs: {
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-container', {
    staticClass: "text-xs-center"
  }, [_c('v-flex', {
    attrs: {
      "xs4": "",
      "mb-3": ""
    }
  }, [_c('v-img', {
    attrs: {
      "src": "/static/img/logo_white_bg.png",
      "contain": ""
    }
  })], 1), _vm._v(" "), _c('v-card', {
    staticClass: "elevation-12"
  }, [_c('v-toolbar', {
    attrs: {
      "dark": "",
      "color": "primary"
    }
  }, [_c('v-toolbar-title', [_vm._v("Password Reset")])], 1), _vm._v(" "), _c('v-card-text', [(_vm.emailValid) ? _c('div', [_c('v-alert', {
    attrs: {
      "value": true,
      "color": "warning"
    }
  }, [_vm._v(" " + _vm._s(_vm.emailValid) + " ")])], 1) : _vm._e(), _vm._v(" "), (_vm.emailSent) ? _c('div', [_c('v-alert', {
    attrs: {
      "value": true,
      "color": "success"
    }
  }, [_vm._v(" " + _vm._s(_vm.emailSent) + " ")])], 1) : _vm._e(), _vm._v(" "), _c('v-form', {
    ref: "form",
    attrs: {
      "lazy-validation": ""
    },
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "email",
      "label": "Enter Email Address",
      "rules": _vm.emailRules,
      "required": ""
    },
    model: {
      value: (_vm.user.username),
      callback: function($$v) {
        _vm.$set(_vm.user, "username", $$v)
      },
      expression: "user.username"
    }
  })], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "to": "/login"
    }
  }, [_c('v-btn', [_vm._v(" Go Back ")])], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.passwordReset
    }
  }, [_vm._v("Submit")])], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-44721add"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/passwordresetrequest.vue
// module id = 1055
// module chunks = 2